import PropTypes from "prop-types";
import React from "react";
import Rail from "web/react/components/rail/rail";
import RelatedSearchProductImages from "./related-search-product-images";
import styles from "./related-searches-rail.css";

function RelatedSearchesRail({ relatedSearches, features }) {
    let breadCrumbCount = 0;
    return (
        <Rail
            title="Related Searches"
            analyticsLabel="related_searches"
            className={styles.railWrapper}
            itemScope=""
            itemType="http://schema.org/BreadcrumbList"
            railsMoreButtonPlacement={features.uj_rails_more_button_placement}
            peekingCard={features.uj_peeking_card}
        >
            {relatedSearches.map((relatedSearch) => {
                if (relatedSearch.is_breadcrumb) {
                    breadCrumbCount++;
                }
                return (
                    <div
                        className={styles.cardWrapper}
                        key={relatedSearch.url}
                        itemProp={relatedSearch.is_breadcrumb && "itemListElement"}
                        itemScope={relatedSearch.is_breadcrumb && ""}
                        itemType={relatedSearch.is_breadcrumb && "http://schema.org/ListItem"}
                    >
                        <div className={styles.relatedSearchCard}>
                            <a
                                href={relatedSearch.url}
                                itemProp={relatedSearch.is_breadcrumb && "item"}
                            >
                                <RelatedSearchProductImages feedUrl={relatedSearch.url} />
                            </a>
                            <a
                                href={relatedSearch.url}
                                className={styles.relatedSearchTerm}
                                itemProp={relatedSearch.is_breadcrumb && "item"}
                            >
                                {relatedSearch.text}
                            </a>
                        </div>
                        {relatedSearch.is_breadcrumb && (
                            <meta itemProp="position" content={breadCrumbCount} />
                        )}
                    </div>
                );
            })}
        </Rail>
    );
}

RelatedSearchesRail.propTypes = {
    features: PropTypes.objectOf(PropTypes.string),
    relatedSearches: PropTypes.array.isRequired,
};

export default RelatedSearchesRail;
